import {
  LocalPhone,
  LocationCity,
  Poll,
  Task,
  Vaccines,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Campaign,
  Group,
  Schedule,
  Tune,
  Settings as SettingsIcon,
  Science,
  People,
  Hub as HubIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import {
  ChatIcon,
  DashboardIcon,
  SettingIcon,
  StoreIcon,
} from "assets/icons/NavIcons";

export const HOME = "HOME";
export const APPOINTMENTS = "APPOINTMENTS";
export const EHR = "EHR";
export const VITALS = "VITALS";
export const DOCUMENTS = "DOCUMENTS";
export const TASKS = "TASKS";
export const PATIENT = "PATIENTS";
export const SETTINGS = "SETTINGS";
export const SURVEY = "SURVEY";
export const CHAT_HISTORY = "CHAT";
export const STORE = "STORE";
export const ME = "ME";
export const INSIGHTS = "INSIGHTS";
export const TRIALS = "TRIALS";
export const CALLLOGS = "CALLLOGS";
export const ANALYTICS = "ANALYTICS";
export const COMPLETED = "COMPLETED";
export const SITES = "SITES";
export const SITES_OUTREACH = "SITES_OUTREACH";
export const SITES_ONBOARDED = "SITES_ONBOARDED";
export const ONBOARDING = "ONBOARDING";
export const SCHEDULES = "SCHEDULES";
export const CONFIGURATIONS = "CONFIGURATIONS";
export const GENERAL = "GENERAL";
export const AGENT = "AGENT";
export const PROFILE = "PROFILE";
export const CTMS = "CTMS";
export const AGENTS = "AGENTS";
export const CAMPAIGNS = "CAMPAIGNS";
export const CAMPAIGNS_DETAIL = "CAMPAIGNS_DETAIL";
export const MIA = "MIA";
export const MIA_ANALYTICS = "MIA_ANALYTICS";
export const STUDIES = "STUDIES";
export const SUBJECTS = "SUBJECTS";
export const DASHBOARD = "DASHBOARD";

export const ROUTER_OBJECT = [
  // {
  //   label: "Dashboard",
  //   Icon: DashboardIcon,
  //   identifier: HOME,
  //   path: "/home/dashboard",
  // },
  // {
  //   label: "Chat History",
  //   Icon: ChatIcon,
  //   identifier: CHAT_HISTORY,
  //   path: "/chat/history",
  //   // className: "step-3",
  // },
  // {
  //   label: "Survey",
  //   Icon: Poll,
  //   identifier: SURVEY,
  //   path: "/survey/happiness_survey",
  // },
  // {
  //   label: "Store",
  //   // Icon: SvgToMuiIcon(settings_icon),
  //   Icon: StoreIcon,
  //   identifier: STORE,
  //   path: "/store/plans",
  //   // className: "step-3",
  // },
  {
    // Combined analytics home: BARI Campaigns + MIA + Outbound Call analytics
    // stacked on one page (was the standalone "Call Analytics" route).
    label: "Dashboard",
    Icon: DashboardIcon,
    identifier: DASHBOARD,
    path: "/dashboard",
  },
  {
    label: "SITES",
    Icon: LocationCity,
    identifier: SITES,
    path: "/sites/list",
    hasSubItems: true,
    subItems: [
      {
        label: "Outreach",
        Icon: Campaign,
        identifier: SITES_OUTREACH,
        path: "/sites/outreach",
        showCondition: (location) => {
          // Show when on any sites route OR when we have a site query parameter
          const urlParams = new URLSearchParams(location.search);
          const hasSiteQuery = urlParams.get("site");
          return location.pathname.includes("site=") || hasSiteQuery;
        },
      },
      {
        label: "Onboarded",
        Icon: Group,
        identifier: SITES_ONBOARDED,
        path: "/sites/onboarded",
        showCondition: (location) => {
          // Show when on any sites route OR when we have a site query parameter
          const urlParams = new URLSearchParams(location.search);
          const hasSiteQuery = urlParams.get("site");
          return location.pathname.includes("site=") || hasSiteQuery;
        },
      },
    ],
  },
  {
    label: "Studies",
    Icon: Science,
    identifier: STUDIES,
    path: "/studies/list",
  },
  {
    label: "Subjects",
    Icon: People,
    identifier: SUBJECTS,
    path: "/subjects/list",
  },
  {
    label: "Campaigns",
    Icon: Campaign,
    identifier: CAMPAIGNS,
    path: "/campaigns/list",
  },
  {
    // Analytics + list now live on a single page (mirrors the Campaigns/BARI
    // layout), so MIA is a single nav entry with no List/Analytics sub-items.
    label: "MIA",
    Icon: Task,
    identifier: MIA,
    path: "/mia/list",
  },
  {
    label: "Settings",
    // Icon: SvgToMuiIcon(settings_icon),
    Icon: SettingIcon,
    identifier: SETTINGS,
    // path: "/settings/me",
    path: "/settings/profile",
    // className: "step-3",
    hasSubItems: true,
    subItems: [
      {
        label: "Profile",
        Icon: PersonIcon,
        identifier: PROFILE,
        path: "/settings/profile",
        showCondition: (location) => {
          const urlParams = new URLSearchParams(location.search);
          const hasSettingsQuery = urlParams.get("settings");
          return location.pathname.includes("settings") || hasSettingsQuery;
        },
      },
      {
        label: "General",
        Icon: SettingsIcon,
        identifier: GENERAL,
        path: "/settings/general",
        showCondition: (location) => {
          const urlParams = new URLSearchParams(location.search);
          const hasSettingsQuery = urlParams.get("settings");
          return location.pathname.includes("settings") || hasSettingsQuery;
        },
      },
      {
        label: "Integration",
        Icon: HubIcon,
        identifier: CTMS,
        path: "/settings/ctms",
        showCondition: (location) => {
          const urlParams = new URLSearchParams(location.search);
          const hasSettingsQuery = urlParams.get("settings");
          return location.pathname.includes("settings") || hasSettingsQuery;
        },
      },
    ],
  },
  // {
  //   label: "ONBOARDING",
  //   Icon: Task,
  //   identifier: ONBOARDING,
  //   path: "/onboarding/list",
  // },
];

export const getPathNames = () => {
  return window.location.pathname.split("/");
};

// Helper function to get query parameters
export const getQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlParams);
};

// Helper function to check if we have a site ID in query params
export const hasSiteInQuery = () => {
  const queryParams = getQueryParams();
  return queryParams.site && queryParams.site.trim() !== "";
};
